<form [formGroup]="service.priceForm" (submit)="submit()">
  <div mat-dialog-title>
    <h2 *ngIf="data">{{data.commonName ? data.commonName : data.name}}</h2>
    <h2 *ngIf="!data">FICHAR JUGADOR</h2>
  </div>
  
  <mat-dialog-content>
    <mat-form-field *ngIf="!data">
      <mat-label>Jugador</mat-label>
      <input matInput #playerInput placeholder="Select player" formControlName="player"
          [matAutocomplete]="playerAuto" (input)="filter(playerInput)" (focus)="filter(playerInput)">
      <mat-autocomplete #playerAuto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onPlayerSelected(playerInput)">
          <mat-option *ngFor="let player of filteredPlayers" [value]="player">{{player?.name}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Precio</mat-label>
      <input type="number" min="0" max="300" step="5" placeholder="Precio del traspaso (en M€)" matInput formControlName="price">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-icon-button color="warn" mat-dialog-close (click)="service.priceForm.reset({player:null, price:0})">
      <mat-icon>delete</mat-icon>
    </button>
    <button mat-button color="warn" mat-dialog-close (click)="service.priceForm.reset({price: -1})">Cancelar</button>
    <button mat-button type="submit">Firmar</button>
  </mat-dialog-actions>
</form>